/* tslint:disable */
/* eslint-disable */
/**
 * Stututu API
 * REST API for the Stututu car community.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ListActivities200ResponseLinks
 */
export interface ListActivities200ResponseLinks {
    /**
     * 
     * @type {string}
     * @memberof ListActivities200ResponseLinks
     */
    first?: string;
    /**
     * 
     * @type {string}
     * @memberof ListActivities200ResponseLinks
     */
    last?: string;
    /**
     * 
     * @type {string}
     * @memberof ListActivities200ResponseLinks
     */
    prev?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ListActivities200ResponseLinks
     */
    next?: string | null;
}

/**
 * Check if a given object implements the ListActivities200ResponseLinks interface.
 */
export function instanceOfListActivities200ResponseLinks(value: object): value is ListActivities200ResponseLinks {
    return true;
}

export function ListActivities200ResponseLinksFromJSON(json: any): ListActivities200ResponseLinks {
    return ListActivities200ResponseLinksFromJSONTyped(json, false);
}

export function ListActivities200ResponseLinksFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListActivities200ResponseLinks {
    if (json == null) {
        return json;
    }
    return {
        
        'first': json['first'] == null ? undefined : json['first'],
        'last': json['last'] == null ? undefined : json['last'],
        'prev': json['prev'] == null ? undefined : json['prev'],
        'next': json['next'] == null ? undefined : json['next'],
    };
}

export function ListActivities200ResponseLinksToJSON(json: any): ListActivities200ResponseLinks {
    return ListActivities200ResponseLinksToJSONTyped(json, false);
}

export function ListActivities200ResponseLinksToJSONTyped(value?: ListActivities200ResponseLinks | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'first': value['first'],
        'last': value['last'],
        'prev': value['prev'],
        'next': value['next'],
    };
}

